import { gql } from "@apollo/client";

const GET_FIGURA_DE_PROFESIONAL = gql`
query GetFiguraDeProfesional($idEvaluacion: Int!, $idProfesional: Int!) {
  profesionalAsignadoEsEspecialistaConsultor(idEvaluacion: $idEvaluacion, idProfesional: $idProfesional){
    idFiguraProfesional
    descripcion
  }
}`;

export default GET_FIGURA_DE_PROFESIONAL;